import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-dashboard",
  "use": "icon-menu-dashboard-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-menu-dashboard\"><path fill=\"currentColor\" d=\"M0 256a256 256 0 1 1 512 0a256 256 0 1 1-512 0m320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64M144 176a32 32 0 1 0 0-64a32 32 0 1 0 0 64m-16 80a32 32 0 1 0-64 0a32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64a32 32 0 1 0 0 64m-16-144a32 32 0 1 0-64 0a32 32 0 1 0 64 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu/dashboard.svg
// module id = Yw9x
// module chunks = 36